export interface Coordinates {
    lat?: number;
    long?: number;
}
